import React, { useState } from "react";
import MyLeaveRequests from "../components/leave/MyLeaveRequests";
import LeaveRequests from "../components/leave/LeaveRequests";

const tabs = ["My Leaves", "Team Requests"];

const LeaveDashboard = () => {
  const userRole = sessionStorage.getItem("userrole");
  
  const tabs =
  userRole === "1" ? ["My Leaves", "Team Requests"] : ["My Leaves"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "My Leaves":
        return (
          <div>
            <MyLeaveRequests />
          </div>
        );
      case "Team Requests":
        return (
          <div>
            <LeaveRequests />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="relative flex min-h-screen flex-col bg-white group/design-root overflow-x-hidden">
      <div className="layout-container flex h-full grow flex-col">
        <div className="flex flex-1 justify-center py-5">
          <div className="layout-content-container flex flex-col flex-1">
            {/* <h1 className="text-2xl font-bold text-[#111518] mb-6">
              Leave Requests
            </h1> */}

            {/* Tabs */}
            <div className="flex flex-wrap gap-2 border-b border-[#dce1e5] mb-4">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 text-lg font-medium  font-bold ${
                    activeTab === tab
                      ? "border-b-2 border-black text-black"
                      : "text-black"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div>{renderTabContent()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveDashboard;
